import React from 'react';
import { Text, View } from 'elements/index';
import { T } from 'helpers/i18n';
const NoData = () => (React.createElement(View, { row: true, style: { flex: 1, alignItems: 'center', justifyContent: 'center', } },
    React.createElement(Text, { style: { fontSize: 20, lineHeight: 50, } }, T('noData'))));
export default NoData;



//////////////////
// WEBPACK FOOTER
// ./src/components/NoData.tsx
// module id = 541
// module chunks = 0